import { render, staticRenderFns } from "./ContactMobile.vue?vue&type=template&id=dcebfd2a&scoped=true"
import script from "./ContactMobile.vue?vue&type=script&lang=js"
export * from "./ContactMobile.vue?vue&type=script&lang=js"
import style0 from "./ContactMobile.vue?vue&type=style&index=0&id=dcebfd2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcebfd2a",
  null
  
)

export default component.exports